var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrapefruits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3017",
    "data-name": "Group 3017",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.191,
    height: 18.191,
    viewBox: "0 0 18.191 18.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11226",
    "data-name": "Rectangle 11226",
    width: 18.191,
    height: 18.191,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3016",
    "data-name": "Group 3016",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    d: "M22.86,46.3a.838.838,0,0,1-.1-.006,8.41,8.41,0,0,1-4.188-1.73.819.819,0,0,1-.311-.6.83.83,0,0,1,.241-.637l3.765-3.766a.818.818,0,0,1,.581-.243.845.845,0,0,1,.571.225.815.815,0,0,1,.259.6v5.322a.825.825,0,0,1-.24.584A.812.812,0,0,1,22.86,46.3Zm-.009-6.243a.085.085,0,0,0-.063.028l-3.765,3.766a.1.1,0,0,0-.028.074.084.084,0,0,0,.032.063,7.677,7.677,0,0,0,3.823,1.579h.01a.085.085,0,0,0,.059-.026.1.1,0,0,0,.028-.068V40.152A.1.1,0,0,0,22.851,40.058Z",
    transform: "translate(-13.798 -29.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    d: "M8.931,39.4h0a.815.815,0,0,1-.646-.313A8.412,8.412,0,0,1,6.556,34.9a.818.818,0,0,1,.2-.64.83.83,0,0,1,.621-.279H12.7a.827.827,0,0,1,.584,1.411L9.518,39.159A.824.824,0,0,1,8.931,39.4ZM7.378,34.715a.1.1,0,0,0-.072.033.082.082,0,0,0-.021.066,7.679,7.679,0,0,0,1.579,3.823.086.086,0,0,0,.068.032A.1.1,0,0,0,9,38.64l3.765-3.766a.093.093,0,0,0-.066-.159Z",
    transform: "translate(-4.949 -25.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    "data-name": "Path 3447",
    d: "M42.059,39.324h0a.818.818,0,0,1,.581.243l3.765,3.765a.83.83,0,0,1,.241.637.82.82,0,0,1-.311.6,8.412,8.412,0,0,1-4.188,1.73.821.821,0,0,1-.919-.822V40.151a.815.815,0,0,1,.259-.6A.845.845,0,0,1,42.059,39.324Zm-.009,6.243h.01a7.678,7.678,0,0,0,3.823-1.579.084.084,0,0,0,.032-.063.1.1,0,0,0-.028-.074l-3.765-3.766a.085.085,0,0,0-.063-.028h0a.105.105,0,0,0-.07.028.085.085,0,0,0-.027.066v5.322A.094.094,0,0,0,42.05,45.567Z",
    transform: "translate(-31.151 -29.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    d: "M12.7,16.434H7.377a.83.83,0,0,1-.621-.279.818.818,0,0,1-.2-.64,8.408,8.408,0,0,1,1.73-4.187.815.815,0,0,1,.645-.313.824.824,0,0,1,.587.243l3.765,3.766a.827.827,0,0,1-.584,1.411ZM8.931,11.748a.086.086,0,0,0-.068.032A7.675,7.675,0,0,0,7.284,15.6a.082.082,0,0,0,.021.066.1.1,0,0,0,.072.033H12.7a.093.093,0,0,0,.066-.159L9,11.776A.1.1,0,0,0,8.931,11.748Z",
    transform: "translate(-4.949 -8.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    "data-name": "Path 3449",
    d: "M2.783.115a.366.366,0,0,1,.259.107l5.61,5.61a1.558,1.558,0,0,1,.361,1.583,1.083,1.083,0,0,0,1.36,1.36,1.662,1.662,0,0,1,.5-.079h0a1.513,1.513,0,0,1,1.079.44l5.61,5.61a.367.367,0,0,1,0,.519,10.74,10.74,0,0,1-3.589,2.375,10.888,10.888,0,0,1-4.1.8,10.665,10.665,0,0,1-3.98-.761A10.387,10.387,0,0,1,.092,11.837,10.673,10.673,0,0,1-.647,7.8,10.891,10.891,0,0,1,.171,3.757,10.742,10.742,0,0,1,2.524.222.366.366,0,0,1,2.783.115Zm7.262,9.444A1.816,1.816,0,0,1,8.314,7.193a.828.828,0,0,0-.181-.842L2.788,1a10.078,10.078,0,0,0-2.7,6.8,9.716,9.716,0,0,0,9.792,9.9A10.067,10.067,0,0,0,16.783,15L11.437,9.655a.785.785,0,0,0-.561-.225h0a.929.929,0,0,0-.281.044A1.819,1.819,0,0,1,10.045,9.559Z",
    transform: "translate(0.49 -0.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3450",
    "data-name": "Path 3450",
    d: "M28.782,13.838a.367.367,0,0,1-.209-.668,7.936,7.936,0,0,0,.83-.661L24.725,7.832a.691.691,0,0,0-.685-.167,1.676,1.676,0,0,1-2.059-2.059.691.691,0,0,0-.167-.685L17.137.243a7.961,7.961,0,0,0-.66.829.367.367,0,1,1-.6-.417,8.706,8.706,0,0,1,1-1.2.367.367,0,0,1,.259-.107.367.367,0,0,1,.259.107L22.333,4.4a1.424,1.424,0,0,1,.352,1.41.943.943,0,0,0,1.149,1.149,1.424,1.424,0,0,1,1.41.352l4.943,4.943a.367.367,0,0,1,0,.519,8.682,8.682,0,0,1-1.2,1A.365.365,0,0,1,28.782,13.838Z",
    transform: "translate(-11.944 0.489)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrapefruits);
export default __webpack_public_path__ + "static/media/grapefruits.0128fd7b9316a958ce2bcba69bbd41d1.svg";
export { ForwardRef as ReactComponent };